import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "@/index.css";
import App from "@/App";
import { toast } from "sonner";

// Safety net: any unhandled API error becomes a friendly toast instead of crashing the screen
window.addEventListener("unhandledrejection", (event) => {
  const detail = event.reason?.response?.data?.detail;
  if (event.reason?.isAxiosError || detail) {
    event.preventDefault();
    toast.error(typeof detail === "string" ? detail : "Não foi possível concluir a ação. Tente novamente.");
  }
});

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
    <Toaster richColors position="top-right" />
  </QueryClientProvider>
);
